import {
  moderatedСastingsDataRequest,
  moderatedСastingsDataSuccess,
  moderatedСastingsDataFailure,
  castingsDataRequest,
  castingsDataSuccess,
  castingsDataFailure,
  archivedCastingsDataRequest,
  archivedCastingsDataSuccess,
  archivedCastingsDataFailure,
  declinedCastingsDataRequest,
  declinedCastingsDataSuccess,
  declinedCastingsDataFailure,
} from '.';
import { AdminService } from '../../services/requests';

const CastingsHelper = {
  getCastingsInModerated: () => async (dispatch) => {
    dispatch(moderatedСastingsDataRequest());
    const castingsSavedData = JSON.parse(sessionStorage.getItem('moderatedCastings'));
    try {
      const res = await AdminService.getCastingsInModerated(1, castingsSavedData?.direction || 'desc', castingsSavedData?.mainCategory || '');
      if (res) {
        dispatch(moderatedСastingsDataSuccess({ data: res.data, last: res.last }));
      }
    } catch (err) {
      dispatch(moderatedСastingsDataFailure(err));
    }
  },

  getAllCastings: () => async (dispatch) => {
    dispatch(castingsDataRequest());
    const castingsSavedData = JSON.parse(sessionStorage.getItem('allCastings'));
    try {
      const res = await AdminService.getAllCastings(1, castingsSavedData?.direction || 'desc', castingsSavedData?.mainCategory || '');
      if (res) {        
        dispatch(castingsDataSuccess({ data: res.data, last: res.last }));
      }
    } catch (err) {
      dispatch(castingsDataFailure(err));
    }
  },

  getArchivedCastings: () => async (dispatch) => {
    dispatch(archivedCastingsDataRequest());
    const castingsSavedData = JSON.parse(sessionStorage.getItem('archivedCastings'));
    try {
      const res = await AdminService.getArchivedCastings(1, castingsSavedData?.direction || 'desc', castingsSavedData?.mainCategory || '');
      if (res) {
        dispatch(archivedCastingsDataSuccess({ data: res.data, last: res.last }));
      }
    } catch (err) {
      dispatch(archivedCastingsDataFailure(err));
    }
  },

  getDeclinedCastings: () => async (dispatch) => {
    dispatch(declinedCastingsDataRequest());
    const castingsSavedData = JSON.parse(sessionStorage.getItem('declinedCastings'));
    try {
      const res = await AdminService.getDeclinedCastings(1, castingsSavedData?.direction || 'desc', castingsSavedData?.mainCategory || '');
      if (res) {
        dispatch(declinedCastingsDataSuccess({ data: res.data, last: res.last }));
      }
    } catch (err) {
      dispatch(declinedCastingsDataFailure(err));
    }
  }
};

export default CastingsHelper;
